import { render } from "./Discounts.vue?vue&type=template&id=cbad936a&scoped=true"
import script from "./Discounts.vue?vue&type=script&lang=js"
export * from "./Discounts.vue?vue&type=script&lang=js"

import "./Discounts.vue?vue&type=style&index=0&id=cbad936a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbad936a"]])

export default __exports__